import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client";
import { Status } from "../components/Ui";

const STATUSES = ["", "success", "pending", "review", "partial", "refunded"];

export default function AdminOrders() {
  const navigate = useNavigate();
  const [data, setData] = useState({ orders: [], total: 0 });
  const [f, setF] = useState({ status: "", email: "", page: 1 });

  useEffect(() => {
    const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    api.get(`/admin/orders?${q}`).then((r) => setData(r.data)).catch(() => {});
  }, [f]);

  return (
    <div>
      <h1>Orders <span className="muted">({data.total})</span></h1>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
        {STATUSES.map((s) => (
          <button key={s} onClick={() => setF((x) => ({ ...x, status: s, page: 1 }))}
            className={`quick-btn${f.status === s ? " on" : ""}`} style={{ textTransform: "capitalize" }}>
            {s || "All"}
          </button>
        ))}
        <input className="input" style={{ width: 220, marginLeft: "auto" }} placeholder="Filter by email"
          value={f.email} onChange={(e) => setF((x) => ({ ...x, email: e.target.value, page: 1 }))} />
      </div>

      <div className="scroll">
        <table className="table">
          <thead>
            <tr>{["Order", "Product", "Customer", "Game ID", "Price", "Status", "Date"].map((h) => <th key={h}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {data.orders.map((o) => (
              <tr
                key={o.orderId}
                role="link"
                tabIndex={0}
                onClick={() => navigate(`/admin/orders/${o.orderId}`)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    navigate(`/admin/orders/${o.orderId}`);
                  }
                }}
                style={{ cursor: "pointer" }}
                title="View and edit this order"
              >
                <td className="mono" style={{ fontWeight: 700, textDecoration: "underline" }}>
                  {o.orderId}
                </td>
                <td>{o.p_info}<div className="muted small">{o.amount}</div></td>
                <td className="small">{o.customer_email}</td>
                <td className="mono">{o.userId}{o.zoneId ? `|${o.zoneId}` : ""}</td>
                <td className="tabular" style={{ fontWeight: 800 }}>₹{o.price}</td>
                <td><Status value={o.status} /></td>
                <td className="muted small">{new Date(o.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
        <button className="btn ghost" disabled={f.page === 1} onClick={() => setF((x) => ({ ...x, page: x.page - 1 }))}>Previous</button>
        <span className="muted small" style={{ padding: 10 }}>Page {f.page}</span>
        <button className="btn ghost" disabled={data.orders.length < 50} onClick={() => setF((x) => ({ ...x, page: x.page + 1 }))}>Next</button>
      </div>
    </div>
  );
}
